var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"date-thumbnail",style:({ backgroundImage: ("url(" + (_vm.props.events && _vm.props.events[0].image)) }),on:{"click":_vm.listeners.click}},[_c('p',[_vm._v(_vm._s(_vm.props.day))])])}
var staticRenderFns = []

export { render, staticRenderFns }